import { defineStore } from 'pinia';

export const useSpotRatesStore = defineStore('spot-rates', () => {
    const checkoutInterval = ref(60);
    const checkoutTimerTick = ref(checkoutInterval.value);
    const checkoutTimerId = ref(null);
    const type = ref('sell');
    const data = ref({});
    const spotRates = computed(() => data.value[type.value] || {});
    const chartRanges         = ref({});
    const ratio = ref('');
    const callbacks = {};
    const chartsPageInitialized = ref(false);
    const datetime = ref('');

    const internalCurrencyRates = ref({});

    const exchangeRates = computed(async () => {
        if (Object.keys(internalCurrencyRates.value).length === 0) {
            internalCurrencyRates.value = await getFromClient('settings/currency-rates');
        }

        return internalCurrencyRates.value;
    });

    function initData(newData) {
        const structured = { sell: {} };
        if (newData.buy) {
            structured.buy = {};
        }

        Object.entries(newData).forEach(([section, sectionData]) => {
            if (section === 'datetime') {
                datetime.value = sectionData;
                return;
            }
            Object.entries(sectionData).forEach(([metalCode, metalData]) => {
                if (!structured[section]) {
                    structured[section] = {};
                }
                structured[section][metalCode] = {
                    oz: { ...metalData }
                };
            });
        });

        data.value = structured;
    }

    function initChartData(metalCode, unitCode, rangesArray) {
        if (!chartRanges.value[metalCode]) chartRanges.value[metalCode] = {}
        chartRanges.value[metalCode][unitCode] = rangesArray
    }

    function addChartPoint(metalCode, unitCode, point) {
        if (!chartRanges.value[metalCode]) chartRanges.value[metalCode] = {}
        if (!chartRanges.value[metalCode][unitCode]) chartRanges.value[metalCode][unitCode] = []
        chartRanges.value[metalCode][unitCode].push(point)
    }


    function countdownCheckoutTimer(callback) {
        checkoutTimerTick.value--;
        if (checkoutTimerTick.value <= 0) {
            checkoutTimerTick.value = checkoutInterval.value;
            callback();
        }
    }

    function startCheckoutTimer(totalSeconds, remainingSeconds, callback) {
        stopCheckoutTimer();
        setCheckoutTimerData(totalSeconds, remainingSeconds);
        checkoutTimerId.value = setInterval(() => countdownCheckoutTimer(callback), 1000);
    }

    function setCheckoutTimerData(totalSeconds, remainingSeconds) {
        checkoutInterval.value = totalSeconds;
        checkoutTimerTick.value = remainingSeconds;
    }

    function addCallback(id, callback) {
        callbacks[id] = callback;
    }
    function removeCallback(id) {
        delete callbacks[id];
    }

    function stopCheckoutTimer() {
        clearInterval(checkoutTimerId.value);
        checkoutTimerId.value = null;
    }

    return {
        initData,
        type,
        data,
        datetime,
        spotRates,
        chartRanges,
        addChartPoint,
        initChartData,
        startCheckoutTimer,
        addCallback,
        removeCallback,
        checkoutTimerTick,
        setCheckoutTimerData,
        callbacks,
        ratio,
        chartsPageInitialized,
        exchangeRates,
    };
});
